export const productInfo = [
  {
    id: 1,
    title: "The Power of Your Subconscious Mind",
    price: "1.99",
    image:
      "https://m.media-amazon.com/images/I/71UwSHSZRnS._AC_UY327_FMwebp_QL65_.jpg",
    rating: 5,
  },
  {
    id: 2,
    title: "Prestige IRIS Plus 750 watt mixer grinder",
    price: "34.49",
    image:
      "https://m.media-amazon.com/images/I/51HfqyUaHyL._AC_UY327_FMwebp_QL65_.jpg",
    rating: 4,
  },
  {
    id: 3,
    title:
      "Fitbit Sense Advanced Smartwatch with Tools for Heart Health, Stress Management & Skin Temperature Trends, Alexa Built-in, Carbon/Graphite, One Size (S & L Bands Included)",
    price: "18.49",
    image:
      "https://m.media-amazon.com/images/I/51MUa0WUSKL._AC_UY327_FMwebp_QL65_.jpg",
    rating: 4,
  },
  {
    id: 4,
    title: "Marshall Acton III Bluetooth Home Speaker, Black",
    price: "35.99",
    image:
      "https://m.media-amazon.com/images/I/712gXKvgZnL._AC_UY327_FMwebp_QL65_.jpg",
    rating: 5,
  },
  {
    id: 5,
    title:
      "Apple 2022 iPad Air M1 Chip (10.9-inch/27.69 cm, Wi-Fi, 64GB) - Blue (5th Generation)",
    price: "54.49",
    image:
      "https://m.media-amazon.com/images/I/71VbHaAqbML._AC_UY327_FMwebp_QL65_.jpg",
    rating: 4,
  },
  {
    id: 6,
    title:
      "Samsung 108 cm (43 inches) Crystal 4K Neo Series Ultra HD Smart LED TV UA43AUE65AKXXL (Black)",
    price: "29.99",
    image:
      "https://m.media-amazon.com/images/I/71B7sRIydwL._AC_UY327_FMwebp_QL65_.jpg",
    rating: 3,
  },
];
